import 'slick-carousel';

( function ( $ ) {

	$('.article-gallery').slick({
		slide: '.article-gallery__item',
		rows: 0,
		infinite: true,
		slidesToShow: 1,
		dots: true,
		prevArrow: $('.article-gallery__arrow--left'),
		nextArrow: $('.article-gallery__arrow--right'),
	});

} )( jQuery );
